var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobGammaPilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bcbcbc;}.cls-2{fill:#777;}.cls-3{fill:#e8e8e8;}.cls-4{fill:#301d29;}.cls-5{fill:#5b4956;}.cls-6{fill:#1fa000;}.cls-7{fill:#cecece;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "279.5 280.5 0.5 280.5 1.5 241.5 6.49 210.65 140 191.5 273.51 210.65 278.5 241.5 279.5 280.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "251.65 223.02 28.07 223.02 4.42 109.69 41.89 118.98 72.3 116.71 207.42 116.71 237.83 118.98 275.3 109.69 251.65 223.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "221.29 59.27 179.6 25.85 101.72 25.85 60.03 59.27 57.15 138.85 70.24 207.03 106.98 207.03 174.35 207.03 211.09 207.03 224.18 138.85 221.29 59.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "257.92 302.94 22.65 302.94 4.97 205.65 140.29 191.54 275.61 205.65 257.92 302.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "154.71 50.32 125.87 50.32 75.04 81.74 70.93 141.77 78.47 205.64 118.07 229.52 162.5 229.52 201.95 205.64 209.64 124.08 205.53 81.74 154.71 50.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "72.8 162.89 83.83 148.85 98.74 176.55 116.26 182.13 136.02 241.38 77.16 214.66 72.8 162.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "217.17 123.67 183.06 145.51 178.32 131.42 140.66 166.79 103.17 131.42 98.89 145.51 63.41 123.67 67.8 104.33 140.29 58.89 212.78 104.33 217.17 123.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "155.33 91.28 140.62 124.35 126.15 91.28 61.65 116.52 140.29 23.92 218.92 116.52 155.33 91.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "206.52 162.89 196.36 148.85 181.46 176.55 163.93 182.13 144.18 241.38 203.06 214.66 206.52 162.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "223.81 45.48 180.31 19.07 100.27 19.07 56.77 45.48 53.77 136.13 67.34 206.75 79.96 206.75 65.71 149.91 80.57 92.49 114.37 72.58 166.21 72.58 200 92.49 214.86 149.91 200.62 206.75 213.24 206.75 226.81 136.13 223.81 45.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "228.27 267.65 140.66 297.65 52.31 267.65 11.93 205.47 47.78 149.4 81.78 173.66 99.25 200.6 140.29 213.26 181.33 200.6 198.8 173.66 232.8 149.4 268.64 205.47 228.27 267.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "163.83 72.58 116.14 72.58 100.94 17.89 179.03 17.89 163.83 72.58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobGammaPilot);
export default __webpack_public_path__ + "static/media/mob-gamma-pilot.b41d966286a2d15c487087fff3191566.svg";
export { ForwardRef as ReactComponent };